module.exports = __webpack_public_path__ + "static/img/xi_13.1674bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_13.png
// module id = MLBA
// module chunks = 1